// extracted by mini-css-extract-plugin
export default {"primaryButton":"Buttons_primaryButton__-bvDz","whiteButton":"Buttons_whiteButton__eSOt8","primaryButton__input":"Buttons_primaryButton__input__1q36F"};